
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TournamentIcon',
  props: {
    tournamentId: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 16
    }
  },

  data() {
    return {
      currentExtensionIndex: 0,
      extensions: ['png', 'webp']
    };
  },

  watch: {
    tournamentId() {
      // Reset dell'indice quando cambia il competitorId
      this.currentExtensionIndex = 0;
    }
  },

  methods: {
    getIconPath(tournamentId: string) {
      // Controlla se ha icon_id (sport dallo store) o solo icon (sport di fallback/sottomenu)
      if (tournamentId) {
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisTournaments/${tournamentId}.png`
        );
      } else {
        // Fallback generico
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisTournaments/3467550448.png`
        ); // tennis
      }
    },
    handleImageError(event: any) {
      const tournamentId = this.tournamentId || '3467550448';
      const currentExtension = this.extensions[this.currentExtensionIndex];

      // Prova la prossima estensione disponibile
      if (this.currentExtensionIndex < this.extensions.length - 1) {
        this.currentExtensionIndex++;
        const nextExtension = this.extensions[this.currentExtensionIndex];
        event.target.src =
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisTournaments/${tournamentId}.${nextExtension}`;
      } else {
        // Se tutte le estensioni sono fallite, usa il fallback generico
        event.target.src =
          process.env.VUE_APP_URL_CLOUDFRONT +
          '/svg/illinoisTournaments/torneo.webp';
      }
    }
  }
});
